import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/model/treeModel.ts";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { combine, createEvent, createStore, merge } from 'effector';
import { apiToNodeTypeMap, isBimRefType, isBimType, isGroupType } from "../../../classifier-service/adapters";
import { getChildren } from "../../../classifier-service";
import { createBimNodeKey, createChildTree, createGroupNodeKey, createReferenceNodeKey } from "../createTree";
export function createTreeModel(_ref) {
  var nodes$ = _ref.nodes$,
      currentUserClassifier$ = _ref.currentUserClassifier$,
      onCreatedNode = _ref.onCreatedNode,
      dynamicMode$ = _ref.dynamicMode$,
      treeOrderMapTriggers = _ref.treeOrderMapTriggers;
  var setInCreateNode = createEvent({
    name: "setInCreateNode",
    sid: "-t05a8o"
  });
  var setInCreateRootNode = createEvent({
    name: "setInCreateRootNode",
    sid: "mvivf4"
  });
  var inCreateNode$ = createStore(null, {
    name: "inCreateNode$",
    sid: "-1xhtuk"
  }).on(setInCreateNode, function (_, next) {
    var _next$parentNodeRef;

    return (next === null || next === void 0 ? void 0 : (_next$parentNodeRef = next.parentNodeRef) === null || _next$parentNodeRef === void 0 ? void 0 : _next$parentNodeRef.type) === 'UserClassifierNode' ? {
      parentNodeRef: null
    } : next;
  }).on(setInCreateRootNode, function () {
    return {
      parentNodeRef: null
    };
  }).reset(onCreatedNode);
  var treeOrderMap$ = createStore({}, {
    name: "treeOrderMap$",
    sid: "-fhp737"
  });
  treeOrderMap$.on(merge(_toConsumableArray(treeOrderMapTriggers || []), {
    sid: "ikccgy"
  }), function (prev, _ref2) {
    var entityPriorityOrders = _ref2.entityPriorityOrders;

    var newMap = _objectSpread({}, prev);

    entityPriorityOrders.forEach(function (order) {
      var type = apiToNodeTypeMap[order.entityType];

      if (isGroupType(type)) {
        var key = createGroupNodeKey({
          id: order.entityId
        });
        newMap[key] = order.priorityOrder;
      } else if (isBimType(type)) {
        var _key = createBimNodeKey({
          id: order.entityId,
          parentRefId: order.parentRefId,
          type: type
        });

        newMap[_key] = order.priorityOrder;
      } else if (isBimRefType(type)) {
        var _key2 = createReferenceNodeKey({
          id: order.entityId
        });

        newMap[_key2] = order.priorityOrder;
      }
    });
    return newMap;
  });
  var flatTree$ = combine({
    ɔ: [{
      nodes: nodes$,
      currCls: currentUserClassifier$,
      inCreateNode: inCreateNode$,
      dynamicMode: dynamicMode$,
      treeOrderMap: treeOrderMap$
    }, function (_ref3) {
      var nodes = _ref3.nodes,
          currCls = _ref3.currCls,
          inCreateNode = _ref3.inCreateNode,
          dynamicMode = _ref3.dynamicMode,
          treeOrderMap = _ref3.treeOrderMap;

      if (!currCls) {
        return [];
      }

      var rootNodeRefs = getChildren(nodes, currCls);
      return createChildTree({
        nodes: nodes,
        rootNodeRefs: rootNodeRefs,
        inCreateNode: inCreateNode,
        dynamicMode: dynamicMode,
        treeOrderMap: treeOrderMap
      });
    }],
    config: {
      name: "flatTree$",
      sid: "-spjw2u"
    }
  });
  return {
    flatTree$: flatTree$,
    inCreateNode$: inCreateNode$,
    setInCreateNode: setInCreateNode,
    setInCreateRootNode: setInCreateRootNode
  };
}